import { space } from '@op/opds-tokens';
import { IconNotification } from '@op/opds.opux-icons/indicator';
import { Message } from '@messageformat/react';

const InvestmentNotification = (): JSX.Element => {
  return (
    <div style={{ paddingTop: space.default, display: 'flex' }}>
      <IconNotification
        color="notification"
        className="savingscalculator-investment-notification-icon"
      />
      <span className="savingscalculator-labels" style={{ paddingBottom: space.default }}>
        <Message id="investmentNotification_description" />
      </span>
    </div>
  );
};

export default InvestmentNotification;
